<template>
    <b-input-group>
        <template #prepend>
            <b-form-select
                :value="prefix"
                :options="options"
                :disabled="$attrs.disabled"
                class="rounded-right-0"
                @input="setPrefix"
            />
        </template>
        <b-form-input
            :value="number"
            class="rounded-left-0"
            v-bind="$attrs"
            @input="setNumber"
        />
    </b-input-group>
</template>

<script>
    import countryService from '@/services/countryService';

    const COUNTRY_CODES_OPTIONS = countryService.getBankAccountPrefixes();
    const COUNTRY_CODES = COUNTRY_CODES_OPTIONS.map(item => item.value);

    export default {
        name: 'FormFieldIBAN',
        props: {
            value: {
                type: String,
                default: '',
            },
            initialCountryCode: {
                type: String,
                default: 'PL',
                validator: val => COUNTRY_CODES.includes(val),
            },
        },
        computed: {
            options() {
                return countryService.getBankAccountPrefixes();
            },
            prefix() {
                return this.value.slice(0, 2) || this.initialCountryCode;
            },
            number() {
                return this.value.slice(2);
            },
        },
        methods: {
            setPrefix(newPrefix) {
                this.$emit('input', `${newPrefix}${this.number}`);
            },
            setNumber(newNumber) {
                this.$emit('input', `${this.prefix}${newNumber}`);
            },
        },
    };
</script>
